import { io } from 'socket.io-client'
import api from './apiService'

let socket = null

// ─── Socket singleton ─────────────────────────────────────────────────────────

export function getSocket() {
  if (socket) return socket

  const user    = JSON.parse(localStorage.getItem('user') ?? 'null')
  const baseURL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

  socket = io(baseURL, {
    auth: { token: user?.bearer_token ?? '' },
    transports: ['websocket'],
    autoConnect: true,
  })

  return socket
}

export function disconnectSocket() {
  if (socket) { socket.disconnect(); socket = null }
}

// ─── REST ─────────────────────────────────────────────────────────────────────

export async function listColegas() {
  const { data } = await api.get('/staff/colleagues')
  return data
}

export async function listDMs() {
  const { data } = await api.get('/staff/dms')
  return data
}

export async function openOrGetDM(staffId) {
  const { data } = await api.post('/staff/dms/open', { staffId })
  return data.conversaId
}

export async function getDMMessages(conversaId, before) {
  const params = before ? { before } : {}
  const { data } = await api.get(`/staff/dms/${conversaId}/messages`, { params })
  return data
}

export async function markDMRead(conversaId) {
  await api.post(`/staff/dms/${conversaId}/read`)
}

// ─── Socket helpers ───────────────────────────────────────────────────────────

export function joinDM(conversaId) {
  getSocket().emit('join_dm', conversaId)
}

export function sendDM(conversaId, content) {
  getSocket().emit('send_dm', { conversaId, content })
}

export function markDMReadSocket(conversaId) {
  getSocket().emit('mark_dm_read', conversaId)
}
